import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ActiveInactiveCaseStudies,
  createCaseStudies,
  deleteCaseStudies,
  getAllActiveCaseStudies,
  getAllCaseStudies,
  getCaseStudiesByID,
  CaseStudiesDetailsImageUpload,
  updateCaseStudies,
} from "./services/casestudies.services";
import { ICaseStudies } from "./casestudiesModal";

const initialState: ICaseStudies = {
  loading: false,
  formLoading: false,
  error: "",
  CaseStudiesID: null,
  CaseStudiesList: [],
  CaseStudiesDetail: {
    ID: null,
    Title: "",
    SubTitle: "",
    Description: "",
    CaseStudieDetail: "",
    CardImage: "",
    BannerImage: null,
    BreakDown: "",
    SliderImage: null,
    URL: "",
    IsActive: 1,
  },
};

const caseStudieslice = createSlice({
  name: "caseStudies",
  initialState,
  reducers: {
    clearCaseStudiesDetails: (state) => {
      state.CaseStudiesDetail = initialState.CaseStudiesDetail;
    },
    setCaseStudiesID: (state, action) => {
      state.CaseStudiesID = action.payload;
    },
    clearCaseStudiesID: (state) => {
      state.CaseStudiesID = initialState.CaseStudiesID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllCaseStudies.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllCaseStudies.fulfilled,
      (state, action: PayloadAction<ICaseStudies[]>) => {
        state.loading = false;
        state.CaseStudiesList = action.payload || [];
      }
    );
    builder.addCase(getAllCaseStudies.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CaseStudiesList = [];
    });
    builder.addCase(createCaseStudies.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createCaseStudies.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createCaseStudies.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateCaseStudies.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateCaseStudies.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateCaseStudies.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteCaseStudies.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteCaseStudies.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteCaseStudies.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getCaseStudiesByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getCaseStudiesByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.CaseStudiesDetail = action.payload;
    });
    builder.addCase(getCaseStudiesByID.rejected, (state, action) => {
      state.loading = false;
      state.CaseStudiesDetail = initialState.CaseStudiesDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveCaseStudies.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveCaseStudies.fulfilled,
      (state, action: PayloadAction<ICaseStudies[]>) => {
        state.loading = false;
        state.CaseStudiesList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveCaseStudies.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CaseStudiesList = [];
    });
    builder.addCase(ActiveInactiveCaseStudies.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveCaseStudies.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveCaseStudies.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(CaseStudiesDetailsImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(CaseStudiesDetailsImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(CaseStudiesDetailsImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearCaseStudiesDetails, clearCaseStudiesID, setCaseStudiesID } =
  caseStudieslice.actions;
export default caseStudieslice.reducer;
